
import provider from "./config";

export const getCourseClass = async (id) => {
    try {
        const response = await provider.get(`class/${id}/`);
        return response.data;
    } catch (err) {
        throw Error("Turma inválida");
    }
}

export const getVoucheByClass = async (payload) => {
    try {
        const response = await provider.get(`voucher/voucher-code`, {
            params: payload
        });
        return response.data;
    } catch (error) {
        throw Error(error.response.data.error);
    }
}

export const checkVouchersInClass = async (idClass) => {
    try {
        const response = await provider.get(`voucher/class-vouchers`, {
            params: { course_class: idClass }
        });
        return response.data;
    } catch (error) {
        throw Error('Impossível verifica voucher desconto');
    }
}